//#region imports
import { Component, OnInit } from '@angular/core';
import { SignatureComponentModel } from '../../model/signature.model';
import { SignatureService } from 'src/app/services/signature.service';
import { NotificationService } from './../../../../services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SectionService } from 'src/app/services/section.service';
import { P5xService } from 'src/app/services/p5x.service';
import { Globals } from 'src/app/services/globals';
//#endregion

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.css']
})
export class SignatureComponent implements OnInit {
  //#region variables
  showPrevious = false;
  showNext = true;
  showSave = true;
  signatureComponent: SignatureComponentModel;
  public disableSignatureNext: boolean;
  status:string = '';
  //#endregion

  //#region methods
  constructor(
    private signatureService: SignatureService, private sectionService: SectionService,
    private notificationService: NotificationService, private activatedRoute: ActivatedRoute, 
    private p5xService: P5xService, private globals: Globals) {
    // this.signatureService.getShowSignaturePrevious().subscribe((value) => {
    //   this.showPrevious = value;
    // });
    this.signatureService.getShowSignatureNext().subscribe((value) => {
      this.showNext = value;
      this.disableSignatureNext = !value;
    });
    
  }

  ngOnInit() {
    const isRetrieveSimulation = this.sectionService.getIsRetrieveSimulation();
    if (isRetrieveSimulation) {
      this.signatureService.setSignatureProgressBarDetails();
      if(this.globals.isMobile)
      {this.signatureService.setmobileSignatureProgressBarDetails();}
      this.sectionService.setIsRetrieveSimulation(false);
    }
    this.signatureService.getShowSignaturePrevious().subscribe((value) => {
      this.showPrevious = value;
    });
    this.signatureService.getDisableSignatureNext().subscribe((value) => {
      this.disableSignatureNext = value;
      this.showNext = !value;
    });
    if (this.p5xService.getDocumentStatus())    {      this.showPrevious = true;     }

    if (this.signatureService.showPrevSignature)
    {
      this.showPrevious = true;
      this.signatureService.showPrevSignature = false;
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      const thankyou = params.thankyou;
      this.status = params.status;
      if (thankyou === 'true' && this.status.toUpperCase() === 'SIGNED') {
        this.showPrevious = false;
        this.showNext = false;
        this.showSave = false;
        this.signatureService.setThanksProgressBarDetails();
        if(this.globals.isMobile)
        {this.signatureService.setmobileThanksProgressBarDetails();}
        this.signatureComponent = {
          SignatureQuestion1: false, SignatureQuestion2: false, SignatureQuestion3: false,
          SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: true, SignatureRefuse: false
        };
      } else if (thankyou === 'true' && this.status.toUpperCase() === 'REJECT') {
        this.showPrevious = false;
        this.showNext = false;
        this.showSave = false;
        this.signatureService.setThanksProgressBarDetails();
        if(this.globals.isMobile)
        {this.signatureService.setmobileThanksProgressBarDetails();}
        this.signatureComponent = {
          SignatureQuestion1: false, SignatureQuestion2: false, SignatureQuestion3: false,
          SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: false, SignatureRefuse : true
        };
      } else {
        if (!this.signatureComponent) {
          this.signatureComponent = {
            SignatureQuestion1: true, SignatureQuestion2: false, SignatureQuestion3: false,
            SignatureQuestion4: false, SignatureQuestion5: false, SignatureQuestion6: false, SignatureThanks: false, SignatureRefuse: false
          };
        }
        this.signatureService.getSignatureComponent().subscribe((value) => {
          this.signatureComponent = value;
          if (this.signatureComponent){
          if (this.signatureComponent.SignatureQuestion6 === true || this.signatureComponent.SignatureQuestion5 === true) {
            this.showSave = false;             
          }
          
          if (this.signatureService.showPrevSignature)
          {
            this.showPrevious = true;
            this.signatureService.showPrevSignature = false;
          }
          
          if (this.signatureComponent.SignatureThanks === true || this.signatureComponent.SignatureRefuse === true) {
            this.signatureService.setThanksProgressBarDetails();
            if(this.globals.isMobile)
            {this.signatureService.setmobileThanksProgressBarDetails();}
            this.showPrevious = false;
            this.showNext = false;
            this.showSave = false;
          }
          if(this.signatureComponent.SignatureQuestion5 === true){
            setTimeout(()=>{
              window.scrollTo(0, 216);
            }, 500);
          }
        }
        });
      }
    });
  }

  saveDialog() {
    this.notificationService.saveDialog();
  }

  //#endregion
}
